import axios from './../api' // 倒入 api

// 获取用车报表
const getDriverReport = (params) => {
  return axios({
    url: '/api/driver/list',
    method: 'GET',
    params
  })
}

//获取车辆列表
const getCarsMessage = (data) => {
  return axios({
    url: '/api/car/list',
    method: 'POST',
    data
  })
}

//获取司机列表
const getDriverMessage = (data) => {
  return axios({
    url: '/api/driver/list',
    method: 'POST',
    data
  })
}

//获取车辆信息
const getCarDetail = (carId) => {
  return axios({
    url: `/api/car/${carId}`,
    method: 'GET',
  })
}

//获取司机信息
const getDriverDetail = (driverId) => {
  return axios({
    url: `/api/driver/${driverId}`,
    method: 'GET',
  })
}

//新增车辆
const addCar = (data) => {
  return axios({
    url: `/api/car`,
    method: 'POST',
    data
  })
}

//修改车辆
const modifyCar = (data) => {
  return axios({
    url: `/api/car`,
    method: 'PUT',
    data
  })
}

//新增司机
const addDriver = (data) => {
  return axios({
    url: `/api/driver`,
    method: 'POST',
    data
  })
}

//修改司机
const modifyDriver = (data) => {
  return axios({
    url: `/api/driver`,
    method: 'PUT',
    data
  })
}

//获取车辆设置
const getCarSet = (carId) => {
  return axios({
    url: `/api/car/set/${carId}`,
    method: 'GET'
  })
}

//提交车辆设置
const setCar = (data) => {
  return axios({
    url: `/api/car/set`,
    method: 'PUT',
    data
  })
}

// 根据imei获取初始里程
const queryMileage = (params) => {
  return axios({
    url: '/api/hardware/query-mileage',
    method: 'GET',
    params
  })
}

//提交司机设置
const setDriver = (data) => {
  return axios({
    url: `/api/driver/set`,
    method: 'PUT',
    data
  })
}

//获取司机
const getDriverSet = (driverId) => {
  return axios({
    url: `/api/driver/set/${driverId}`,
    method: 'GET'
  })
}

//设备绑定
const bindEquipment = (data) => {
  return axios({
    url: `/api/car/hardware/bind`,
    method: 'PUT',
    data
  })
}

//设备解绑
const delEquipment = (hardwareId) => {
  return axios({
    url: `/api/car/hardware/unbind/${hardwareId}`,
    method: 'PUT',
  })
}

//获取设备信息
const getHardware = () => {
  return axios({
    url: `/api/hardware/list`,
    method: 'GET',
  })
}

//获取司机下拉
const getDriverMsgList = () => {
  return axios({
    url: '/api/driver/simple',
    method: 'GET',
  })
}

//获取设备列表
const getHardwareList = (data) => {
  return axios({
    url: '/api/hardware/list',
    method: 'POST',
    data
  })
}

//新增设备
const addHardware = (data) => {
  return axios({
    url: '/api/hardware',
    method: 'POST',
    data
  })
}

//修改设备
const modifyHardware = (data) => {
  return axios({
    url: '/api/hardware',
    method: 'PUT',
    data
  })
}

//获取设备详情
const getHardwareDetail = (hardwareId) => {
  return axios({
    url: `/api/hardware/${hardwareId}`,
    method: 'GET',
  })
}

//删除设备详情
const delHardware = (hardwareId) => {
  return axios({
    url: `/api/hardware/${hardwareId}`,
    method: 'DELETE',
  })
}

//删除车辆
const delCar = (carId) => {
  return axios({
    url: `/api/car/${carId}`,
    method: 'DELETE'
  })
}
//获取人员列表
const getPersonnelMessage = (data) => {
  return axios({
    url: '/api/personnel/list',
    method: 'POST',
    data
  })
}
//新增人员
const addPersonnel = (data) => {
  return axios({
    url: `/api/personnel`,
    method: 'POST',
    data
  })
}
//获取人员信息
const getPersonnelDetail = (carId) => {
  return axios({
    url: `/api/personnel/${carId}`,
    method: 'GET',
  })
}
//修改人员
const modifyPersonnel = (data) => {
  return axios({
    url: `/api/personnel`,
    method: 'PUT',
    data
  })
}
//删除车辆
const delPersonnel = (carId) => {
  return axios({
    url: `/api/personnel/${carId}`,
    method: 'DELETE'
  })
}
//获取人员设置
const getPersonnelSet = (carId) => {
  return axios({
    url: `/api/personnel/set/${carId}`,
    method: 'GET'
  })
}

// 车辆迁移
const carMigrate = (data) => {
  return axios({
    url: `/api/car/migrate`,
    method: 'POST',
    data
  })
}
export default {
  getCarsMessage,
  getCarDetail,
  addCar,
  modifyCar,
  getDriverMessage,
  getCarSet,
  setCar,
  queryMileage,
  getDriverDetail,
  addDriver,
  modifyDriver,
  getDriverSet,
  bindEquipment,
  getHardware,
  delEquipment,
  getDriverMsgList,
  getHardwareList,
  addHardware,
  modifyHardware,
  getHardwareDetail,
  delHardware,
  setDriver,
  getDriverReport,
  delCar,
  getPersonnelMessage,
  addPersonnel,
  getPersonnelDetail,
  modifyPersonnel,
  delPersonnel,
  getPersonnelSet,
  carMigrate
  // getStatuslist,
  // getenergylist
}